import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { CreateSkillVersionRequest } from "../SkillRecord";

import { skillQueryKeys } from "./skillQueryKeys";

interface Args {
  skillId: string;
  request: CreateSkillVersionRequest;
}

export function useCreateVersion(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ skillId, request }: Args) =>
      skillService.createVersion(skillId, request, { orgId }),
    onSuccess: (_data, { skillId }) => {
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.versions(skillId),
      });
      void queryClient.invalidateQueries({
        queryKey: skillQueryKeys.org(orgId),
      });
    },
  });
}
